<template>
  <transition name="showHeader">
    <div v-if="visible" class="header-animat">
      <a-layout-header
        v-if="visible"
        :class="[isFixedHeader && 'ant-header-fixedHeader', sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed', ]"
        :style="{ padding: '0' }">
        <div v-if="mode === 'sidemenu'" class="header">
          <span>{{date}}</span>
        </div>
        <div v-else :class="['top-nav-header-index', theme]">
          <div class="header-index-wide">
            <div class="header-index-left">
              <logo class="top-nav-header" :show-title="device !== 'mobile'"/>
              <s-menu v-if="device !== 'mobile'" mode="horizontal" :menu="menus" :theme="theme" />
              <a-icon v-else class="trigger" :type="collapsed ? 'menu-fold' : 'menu-unfold'" @click="toggle" />
            </div>
          </div>
        </div>
      </a-layout-header>
    </div>
  </transition>
</template>

<script>
import SMenu from '../Menu/'
import Logo from '../tools/Logo'
import { mixin } from '@/utils/mixin'

export default {
  name: 'GlobalHeader',
  components: {
    SMenu,
    Logo
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: 'sidemenu'
    },
    menus: {
      type: Array,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'dark'
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false
    },
    device: {
      type: String,
      required: false,
      default: 'desktop'
    },
    fixedHeader: {
      type: Boolean,
      required: false,
      default: undefined
    }
  },
  computed: {
    isFixedHeader() {
      return this.fixedHeader !== undefined ? this.fixedHeader : this.$store.state.app.fixedHeader
    }
  },
  data () {
    return {
      visible: true,
      oldScrollTop: 0,
      date: new Date()
    }
  },
  mounted () {
    document.addEventListener('scroll', this.handleScroll, { passive: true })

    let _this = this; // Declare a variable referencing Vue instance this for consistent scope
    this.timer = setInterval(() => {
      // _this.date = new Date().toLocaleString(); // Update data date

      var d=new Date(); // Create a Date object
      var localTime = d.getTime();
      var localOffset=d.getTimezoneOffset()*60000; // Get local time offset in milliseconds
      var utc = localTime + localOffset; // utc is GMT time
      var offset =  Number(process.env.VUE_APP_GLOBAL_OFFSET); // e.g. Hawaii time, UTC+10
      var hawaii = utc + (3600000*offset);
      var nd = new Date(hawaii);
      _this.date = nd.toLocaleString(); // Update data date

    }, 1000)
  },
  methods: {
    handleScroll () {
      if (!this.autoHideHeader) {
        return
      }

      const scrollTop = document.body.scrollTop + document.documentElement.scrollTop
      if (!this.ticking) {
        this.ticking = true
        requestAnimationFrame(() => {
          if (this.oldScrollTop > scrollTop) {
            this.visible = true
          } else if (scrollTop > 300 && this.visible) {
            this.visible = false
          } else if (scrollTop < 300 && !this.visible) {
            this.visible = true
          }
          this.oldScrollTop = scrollTop
          this.ticking = false
        })
      }
    },
    toggle () {
      this.$emit('toggle')
    }
  },

  beforeDestroy () {
    document.body.removeEventListener('scroll', this.handleScroll, true);
    if (this.timer) {
      clearInterval(this.timer); // Clear timers before Vue instance destruction
    }
  }
}
</script>

<style lang="less">
@import '../index.less';

.header-animat{
  position: relative;
  z-index: @ant-global-header-zindex;
}
.showHeader-enter-active {
  transition: all 0.25s ease;
}
.showHeader-leave-active {
  transition: all 0.5s ease;
}
.showHeader-enter, .showHeader-leave-to {
  opacity: 0;
}
</style>
